export enum Status {
  Success = 'success',
  Failed = 'failed',
}

export enum BusinessPage {
  LoginByPassword = 'login_by_password',
  LoginByOtp = 'login_by_otp',
  SignupByOtp = 'signup_by_otp',
  LoginByOtpOneCredential = 'login_by_otp_one_credential',
  LoginByPasswordOneCredential = 'login_by_password_one_credential',
  SignupByOtpOneCredential = 'signup_by_otp_one_credential',
  LoginByOtpOneCredentialOptional = 'login_by_otp_one_credential_optional',
  LoginByPasswordOneCredentialOptional = 'login_by_password_one_credential_optional',
  SignupByOtpOneCredentialOptional = 'signup_by_otp_one_credential_optional',
  LoginByToken = 'login_by_token',
  Relogin = 'relogin',
  LoginByIvs = 'login_by_ivs',
  ResetPassword = 'reset_password',
}

export enum LoginMethod {
  PhoneOtp = 'phone_otp',
  EmailOtp = 'email_otp',
  Password = 'password',
  Google = 'google',
  Apple = 'apple',
  Facebook = 'facebook',
  Shopee = 'shopee',
  Biometric = 'biometric',
  QuickLogin = 'quicklogin',
}

export enum AccType {
  TocOneCredential = 'toc_one_credential',
  Tob = 'tob',
}
